import { html } from '@tamagui/tailwind'
import { useState } from 'react'
import { Accordion } from 'tamagui'

// tamagui.dev/ui/accordion. `type="single" collapsible` is the "one open at a time, all closed at
// first" the page brief asks for; the component carries the aria-expanded/aria-controls wiring,
// the keyboard model and the height animation.
//
// Every part is used with `asChild`, because in v3 Accordion.Trigger and Accordion.Content take
// no style props at all (same story as AlertDialog.Content) - so the markup underneath is our own
// html.* with Tailwind classes. The open item is tracked here rather than through the render-prop
// child, which asChild cannot take.
export function Faq({ items }: { items: readonly { q: string; a: string }[] }) {
  const [open, setOpen] = useState<string | undefined>(undefined)

  return (
    <Accordion
      type="single"
      collapsible
      value={open}
      onValueChange={setOpen}
    >
      {items.map((item) => (
        <Accordion.Item
          key={item.q}
          value={item.q}
        >
          <Accordion.Trigger asChild>
            <html.button
              type="button"
              className="flex flex-row items-center justify-between gap-4 w-full min-h-[56px] py-3 text-left bg-transparent border-0 border-b border-border-color-subtle hover:bg-background-subtle focus-visible:outline focus-visible:outline-2 focus-visible:outline-focus-ring"
            >
              <html.span className="text-lg font-semibold text-color">{item.q}</html.span>
              <html.span
                aria-hidden="true"
                className="text-2xl leading-none text-primary-text"
              >
                {open === item.q ? '−' : '+'}
              </html.span>
            </html.button>
          </Accordion.Trigger>

          <Accordion.HeightAnimator>
            <Accordion.Content asChild>
              <html.div className="flex flex-col pb-4">
                <html.p className="max-w-[640px] text-base text-color-secondary">{item.a}</html.p>
              </html.div>
            </Accordion.Content>
          </Accordion.HeightAnimator>
        </Accordion.Item>
      ))}
    </Accordion>
  )
}
